import { render, staticRenderFns } from "./Appendix.vue?vue&type=template&id=2701fc96&scoped=true"
import script from "./Appendix.vue?vue&type=script&lang=js"
export * from "./Appendix.vue?vue&type=script&lang=js"
import style0 from "./Appendix.vue?vue&type=style&index=0&id=2701fc96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2701fc96",
  null
  
)

export default component.exports